import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do criminal defense attorneys get more cases?",
    "a": "Charge-specific pages — DUI, DWAI, domestic violence, drug, federal — each rank separately. Prospects search by charge, not 'criminal defense'. Attorneys who build per-charge pages capture every search intent."
  },
  {
    "q": "Is Google Ads worth it for criminal defense?",
    "a": "Yes for DUI especially — high CPCs but high case value and a tight decision window. We build campaigns with call tracking and after-hours intake handling."
  },
  {
    "q": "How important is the first-call experience?",
    "a": "Decisive. Prospects often call 3–5 firms in an hour. Live answer, immediate consultation, and a credible attorney bio on the site decide who signs."
  },
  {
    "q": "Should we show case results?",
    "a": "Yes — dismissals, reductions, and outcomes (within ethics rules) are the highest-converting content on a defense site. We build out a case-results section by charge type."
  },
  {
    "q": "Do you handle federal defense marketing?",
    "a": "Yes — federal is a separate niche with separate search intent. Federal pages rank quickly because competition is lower than state-level work."
  }
];

export const Route = createFileRoute("/criminal-defense-attorney-marketing-colorado")({
  head: () =>
    industryMarketingHead("Criminal Defense Attorney", "criminal defense law firm", "criminal-defense-attorney-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Criminal Defense Attorney"}
      industryLower={"criminal defense law firm"}
      slug={"criminal-defense-attorney-marketing-colorado"}
      subheadline={"We help Colorado criminal defense attorneys reach prospects at the urgent moment — arrest, DUI, charges — and convert them into signed clients."}
      painPoints={["You compete against bigger firms with massive ad budgets","Prospects shop fast — within hours — and you're not in front of them","Your site doesn't show wins, dismissals, or the credibility prospects need"]}
      serviceDescriptions={{
        seo: "Rank for DUI, DWAI, drug charges, domestic violence, federal, and every charge type across every Colorado market.",
        googleMaps: "Own 'criminal defense attorney near me' in the Map Pack with reviews and credibility signals.",
        webDesign: "Charge-specific landing pages with case results, attorney bios, and 24/7 emergency intake forms.",
        ppc: "Profitable Google Ads tuned to urgent DUI and criminal charge searches with strict tracking.",
        geoAi: "Get cited when prospects ask ChatGPT 'best DUI lawyer in Colorado Springs' or 'criminal defense attorney near me'.",
        socialMedia: "Educational content that builds credibility and authority during the consideration window.",
      }}
      testimonial={{"quote":"Inbound DUI calls tripled. The charge-specific pages convert at a completely different rate than our old generic site.","role":"Defense Attorney","city":"Colorado Springs"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Criminal defense attorney marketing in Colorado Springs","description":"Win DUI and criminal cases across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Criminal defense attorney marketing in Denver","description":"Compete with Denver's largest criminal defense firms."},{"to":"/boulder-digital-marketing","label":"Criminal defense attorney marketing in Boulder","description":"Build defense pipeline across Boulder County courts."}]}
    />
  ),
});
